import { Component, OnInit } from '@angular/core';
import { InfoBannersService } from '../../shared/info-banners.service';

@Component({
  selector: 'app-not-paid-tariff-banner',
  templateUrl: './not-paid-tariff-banner.component.html',
  styleUrls: ['./not-paid-tariff-banner.component.css']
})
export class NotPaidTariffBannerComponent implements OnInit {

  public banner: any;

  constructor(
    private infoBanners: InfoBannersService
  ) {
    infoBanners.banners.map(banners => banners.not_paid_banner).subscribe(banner => {
      this.banner = banner;
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/not-paid-tariff-banner/not-paid-tariff-banner.component.ts